import AddCourses from '../../features/admin/AddCourses'

const AddCoursesPage = () => {
  return (
   <AddCourses/>
  )
}

export default AddCoursesPage
